import { compose, filter, prop, values } from 'ramda';
import { createSelector } from 'reselect';

import { getIdkRegions } from 'features/other/organizationStructureMUI/regions/selectors';
import { byChannelId, restrictBy } from 'features/other/organizationStructureMUI/utils';

import { NAME } from './constants';

export const getCampaignRegionNominations = prop(NAME);

export const getCampaignRegionNominationsFilter = createSelector(
	getCampaignRegionNominations,
	(nominations) => nominations.filter || {},
);

export const getFilteredNominationRegions = createSelector(
	(_, allowedRegions) => allowedRegions,
	getIdkRegions,
	getCampaignRegionNominationsFilter,
	(allowedRegions, regions, regionNominationsFilter) => {
		const filteredRegions = compose(
			restrictBy(allowedRegions),
			filter(byChannelId(regionNominationsFilter.channel)),
			values,
		)(regions);
		if (regionNominationsFilter.region) {
			return filteredRegions.filter((region) => region.id === regionNominationsFilter.region);
		} else {
			return filteredRegions;
		}
	},
);
